export const AUTH_API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const WEBSOCKET_URL = process.env.REACT_APP_API_URL;
